<template>
  <div>
   <sec1 
      title="Disrupt your trading ecosystem with our <br> AI optimized algorithmic trading">
    </sec1>
     <sec2 
      title="WHY USE ALPHAQ FOR TRADING?" 
      titleSub="Explore the facts that make trading with ALPHAQ effortless than manual trading">
    </sec2>
    <sec3 
      title="YOUR ROADMAP TO A NEXT-GENERATION TRADING EXPERIENCE"
      titleSub="Pave your way to financial freedom in these three easy steps through AlphaQ"
    >
    </sec3>
    <sec4
      title="THE ALPHA Q EXPERIENCE"
    ></sec4>
    <sec5 title="What makes AlphaQ distinguishing?"></sec5>
    <sec6 title="Why join AlphaQ"></sec6>
    <sec7 title="Get early access to" titleSub="#Alphaclub"></sec7>
    <sec8 title="PARTNER WITH US"></sec8>
    <sec9 title="Current opportunities"></sec9>
  </div>
</template>
<style>
</style>
<script>
import sec1 from '@/views/homeComponents/home-sec1.vue'
import sec2 from '@/views/homeComponents/home-sec2.vue'
import sec3 from '@/views/homeComponents/home-sec3.vue'
import sec4 from '@/views/homeComponents/home-sec4.vue'
import sec5 from '@/views/homeComponents/home-sec5.vue'
import sec6 from '@/views/homeComponents/home-sec6.vue'
import sec7 from '@/views/homeComponents/home-sec7.vue'
import sec8 from '@/views/homeComponents/home-sec8.vue'
import sec9 from '@/views/homeComponents/home-sec9.vue'


export default {
  name: 'Home',
  components: {
    sec1:sec1,
    sec2:sec2,
    sec3:sec3,
    sec4:sec4,
    sec5:sec5,
    sec6:sec6,
    sec7:sec7,
    sec8:sec8,
    sec9:sec9
  },
  mounted () {
    this.setMenu()
    // if(this.$route.href =="/#about") setTimeout(() =>{ document.getElementById('about').scrollIntoView({behavior: "smooth"});  },1000);
    // else{
      
    // }
  },
  updated(){
  
  },
  methods:{
    setMenu:function(){
      document.querySelectorAll('.top-menu li').forEach(element => { element.children[0].classList.remove('active') })
    if(this.$route.href =="/#about"){
      setTimeout(() =>{
        document.querySelector('.top-menu a[href="/#about"]').classList.add('active');
        document.getElementById('about').scrollIntoView({behavior: "smooth"});
       },10);
    }else{
      document.querySelector('.top-menu a[href="/#"]').classList.add('active')
      window.scrollTo(0, 0);
    }
    }
  },
  created: function () {
   
  },
   watch:{
    $route (to, from){
      this.setMenu()
    }
   }
}
</script>
